import { render, staticRenderFns } from "./ViewListBadge.vue?vue&type=template&id=3f9bc6bd&"
import script from "./ViewListBadge.vue?vue&type=script&lang=js&"
export * from "./ViewListBadge.vue?vue&type=script&lang=js&"
import style0 from "./ViewListBadge.vue?vue&type=style&index=0&id=3f9bc6bd&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f9bc6bd')) {
      api.createRecord('3f9bc6bd', component.options)
    } else {
      api.reload('3f9bc6bd', component.options)
    }
    module.hot.accept("./ViewListBadge.vue?vue&type=template&id=3f9bc6bd&", function () {
      api.rerender('3f9bc6bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/inline/ViewListBadge.vue"
export default component.exports